<template>
  <div>
    <van-nav-bar
      title="生产单管理"
      left-arrow
      @click-left="$router.back()"
    />
    <van-sticky :offset-top="0">
      <van-row>
        <van-col :span="24">
          <base-datetime v-model="queryCondition.begin_delivery_time" label="送货起始日期" />
        </van-col>
      </van-row>
      <van-row>
        <van-col :span="24">
          <base-datetime v-model="queryCondition.end_delivery_time" label="送货截止日期" />
        </van-col>
      </van-row>
      <van-row>
        <van-col :span="24">
          <van-field v-model="queryCondition.goods_name" label="产品名称" placeholder="点此选择产品"
                     @click="showSearchList = true" is-link readonly />
        </van-col>
      </van-row>
      <van-row>
        <van-col :span="12" style="padding-left: 10px; color: #dd6161;
          font-size: 14px; font-weight: bold;">
          起始身份号：{{ form.start_id }}
        </van-col>
        <van-col :span="8" style="text-align: right; padding-right: 10px;
          font-size: 14px; font-weight: bold;">
          <van-checkbox v-model="queryCondition.un_finished_bound" shape="square">只查未绑定</van-checkbox>
        </van-col>
        <van-col :span="4" style="text-align: right; padding-right: 2px;">
          <base-button @click="query">查询</base-button>
        </van-col>
      </van-row>
      <van-row>
        <van-col :span="12" style="padding-left: 10px; color: #dd6161;
          font-size: 14px; font-weight: bold;">
          结束身份号：{{ form.end_id }}
        </van-col>
        <van-col :span="12" style="text-align: right; margin-top: 10px; padding-right: 2px;">
          <base-button type="warning" @click="handleResetQC()">重置</base-button>&nbsp;&nbsp;
          <base-button type="info" @click="handleBind()">绑定</base-button>
        </van-col>
      </van-row>
      <van-popup v-model="showSearchList" :style="{ height: '80%' }" position="bottom">
        <base-search-goods-list @change="onConfirmOfSelectGoods" />
      </van-popup>
    </van-sticky>
    <van-col :span="24">
      <van-pull-refresh v-model="refreshing" @refresh="query">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="query"
        >
          <van-cell v-for="row in data" :key="row.id">
            <van-panel>
              <div>
                <van-row>
                  <van-col :span="14">
                    {{ row.goods_name }}
                  </van-col>
                  <van-col :span="5" style="text-align: right; font-weight: bold; color: #13ce66;">
                    已绑：{{ row.bound_count }}
                  </van-col>
                  <van-col :span="5" style="text-align: right;">
                    未绑：{{ row.count - row.bound_count }}
                  </van-col>
                </van-row>
              </div>
              <div slot="header">
                <van-row>
                  <van-col :span="12">
                    <van-checkbox v-model="row.checked" shape="square">{{ row.code }}</van-checkbox>
                  </van-col>
                  <van-col :span="12" style="color: red; text-align: right;">
                    产品数量：{{ row.count }}
                  </van-col>
                </van-row>
              </div>
              <div slot="footer">
                <van-row>
                  <van-col :span="24">
                    生产日期：{{ row.quality_time }}
                  </van-col>
                </van-row>
              </div>
            </van-panel>
          </van-cell>
        </van-list>
      </van-pull-refresh>
    </van-col>

    <van-popup v-model="showQualityTime" style="width: 100%">
      <van-datetime-picker v-model="selectedProduceTime" type="date" title="请选择"
                           @confirm="bindProducts" @cancel="showQualityTime = false" />
    </van-popup>

    <init :init-states="initStates" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Init from '@/components/base/init'
import { getProduceOrderList } from '@/api/produce/order'
import { trackBindGoods } from '@/api/commons'
import {resetValue} from "../../utils";
export default {
  name: 'ProduceOrderManage',
  components: { Init },
  data() {
    return {
      data: [],
      loading: false,
      finished: false,
      refreshing: false,
      showSearchList: false,
      showQualityTime: false,

      selectedProduceTime: null,
      form: {
        produce_detail_ids: null,
        goods_id: null,
        goods_name: '',
        produce_time: '',
        start_id: null,
        end_id: null,
        selectedRows: [],
        produceDetailIds: [],
        totalCount: 0
      },
      queryCondition: {
        page: this.CONST.PAGINATION.PAGE,
        rows: this.CONST.PAGINATION.MAX_ROWS,
        sort: 'id',
        order: 'desc',
        type: this.CONST.ORDER_BILL_TYPES.find(type => type.name === '生产单').id,

        statuses: '2,3', // 开始制作、制作完成
        begin_delivery_time: this.Utils.dfOfNextDate('{y}-{m}-{d} 00:00:00'),
        end_delivery_time: this.Utils.dfOfNextDate('{y}-{m}-{d} 23:59:59'),
        un_finished_bound: true,
        goods_name: ''
      },
      initStates: [{
        key: 'goods/init'
      }]
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  mounted() {
    const data = localStorage.getItem('trackBindForm')
    if (data) {
      const trackBindForm = JSON.parse(data)
      this.form.start_id = trackBindForm.start_id
      this.form.end_id = trackBindForm.end_id
    } else {
      this.error('请您选择身份号')
      this.$router.back()
    }
    this.query()
  },
  methods: {
    onConfirmOfSelectGoods(goods) {
      this.queryCondition.goods_name = goods.name
      this.showSearchList = false
    },
    query() {
      this.data = []
      this.loading = true
      this.finished = false
      this.refreshing = false
      getProduceOrderList(this.queryCondition).then(resp => {
        const rows = resp.rows || []
        rows.forEach(row => {
          const details = row.details || []
          details.forEach(detail => {
            if (detail.count !== detail.bound_count) {
              this.data.push({
                detail_id: detail.id,
                goods_id: detail.goods_id,
                goods_name: detail.goods_name,
                count: detail.count,
                bound_count: detail.bound_count,
                code: row.code,
                quality_time: row.quality_time,
                checked: false
              })
            }
          })
        })
        this.loading = false
        this.finished = true
      }).catch(error => {
        this.loading = false
        this.finished = true
      })
    },
    handleResetQC() {
      this.Utils.resetValue(this.queryCondition)
      this.queryCondition.statuses = '2,3' // 开始制作、制作完成
      this.queryCondition.begin_delivery_time = this.Utils.dfOfNextDate('{y}-{m}-{d} 00:00:00')
      this.queryCondition.end_delivery_time = this.Utils.dfOfNextDate('{y}-{m}-{d} 23:59:59')
      this.queryCondition.un_finished_bound = true
    },
    handleBind() {
      const selectedRows = []
      const produceDetailIds = []
      let totalCount = 0
      this.data.forEach(row => {
        if (row.checked) {
          selectedRows.push(row)
          produceDetailIds.push(row.detail_id)
          totalCount += (parseInt(row.count - row.bound_count) || 0)
        }
      })
      if (selectedRows && selectedRows.length > 0) {
        this.selectedProduceTime = new Date()
        this.form.selectedRows = selectedRows
        this.form.produceDetailIds = produceDetailIds
        this.form.totalCount = totalCount
        this.showQualityTime = true
      } else {
        this.alert(this.CONST.TIP.SELECT_ONE_LEAST)
      }
    },
    bindProducts() {
      this.confirm(`总共 ${this.form.totalCount} 未绑定，确定绑定吗？`).then(() => {
        const row = this.form.selectedRows[0]
        this.form.goods_id = row.goods_id
        this.form.goods_name = row.goods_name
        this.form.produce_detail_ids = this.form.produceDetailIds.join(',')
        this.form.produce_time = this.Utils.df(this.selectedProduceTime, '{y}-{m}-{d}')
        trackBindGoods(this.form).then(resp => {
          this.showQualityTime = false
          this.success(`已成功绑定数量 ${resp.obj}`)
          this.alert(`已成功绑定数量 ${resp.obj}`)
          this.query()
        })
      }).catch(() => {
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/bind-produce/order-manage.vue